import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { noticeConfigLists,
// 提醒消息列表
setRegularEnv,
// 设置转正日期、提醒日期
getRegularEnv,
// 获取转正日期、提醒日期
switchNoticeConfig,
// 修改提醒状态
delNoticeConfig // 删除提醒
} from 'api/dashboard';
import SetRemind from './setRemind'; // 编辑、添加提醒
import Pagination from '@/components/pagination';
export default {
  components: {
    SetRemind: SetRemind,
    Pagination: Pagination
  },
  data: function data() {
    return {
      activeProbation: this.$route.query.name || 'REGULAR_NOTICE_DAY',
      // 试用期提醒 试用期时长设置
      isSet: true,
      // 转正日期前X天提醒 输入框状态
      isDisabled: true,
      content: '',
      content1: '',
      pageSizes: [20, 50, 100],
      query: {
        page: 1,
        page_size: 20,
        total: 0,
        tableData: []
      }
    };
  },
  mounted: function mounted() {
    this.handleClick();
  },
  methods: {
    getData: function getData(val) {
      var _this = this;
      this.query.page = val || this.query.page;
      var _this$query = this.query,
        page = _this$query.page,
        page_size = _this$query.page_size;
      noticeConfigLists({
        page: page,
        page_size: page_size
      }).then(function (res) {
        if (res && res.code === 1) {
          res.data.list.forEach(function (item) {
            item.is_on = item.is_on === '1';
          });
          _this.query.tableData = res.data.list;
          _this.query.total = res.data.page_data.total;
        }
      });
    },
    sizeChangeHandle: function sizeChangeHandle(v) {
      this.query.page_size = v;
      this.getData(1);
    },
    currentChangeHandle: function currentChangeHandle(v) {
      this.getData(v);
    },
    handleClick: function handleClick() {
      var _this2 = this;
      this.isDisabled = true;
      this.content = 30;
      // 获取转正日期、提醒日期
      getRegularEnv({
        code: this.activeProbation
      }).then(function (res) {
        if (res && res.code) {
          _this2.content = res.data;
          _this2.content1 = !_this2.content ? '' : _this2.content;
        }
      });
      if (this.activeProbation === 'REGULAR_NOTICE_DAY') this.getData(1);
    },
    goBack: function goBack() {
      // 返回
      // if (this.$route.query.name) this.$router.push({ path: '/staff/pemploymenter' })
      // else this.$emit('goBack')
      this.$router.back();
    },
    handleContent: function handleContent() {
      this.content = this.content ? this.content : '0';
    },
    onEdit: function onEdit() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 编辑
              _this3.isSet = !_this3.isSet;
              _this3.isDisabled = false;
              if (_this3.isSet) {
                setRegularEnv({
                  code: _this3.activeProbation,
                  content: _this3.content
                }).then(function (res) {
                  if (res && res.code === 1) {
                    _this3.$message({
                      type: 'success',
                      message: _this3.$t('781')
                    });
                  }
                }).finally(function () {
                  _this3.isDisabled = true;
                });
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onAddRemind: function onAddRemind(row) {
      // 添加提醒
      this.$refs['set-remind'].init(row);
    },
    switchNotice: function switchNotice(row) {
      // 修改提醒状态
      switchNoticeConfig({
        id: row.id,
        is_on: row.is_on ? '1' : '2'
      });
    },
    onDelRemind: function onDelRemind(row) {
      var _this4 = this;
      this.$confirm(this.$t('invite_56'), this.$t('prompt'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        delNoticeConfig({
          id: row.id
        }).then(function (res) {
          _this4.$message.success(res.message);
          _this4.getData(1);
        });
      }).catch(function () {});
    }
  }
};